"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import * as styles from "./Link-css";
export var LinkIconAnimation = /* @__PURE__ */ ((LinkIconAnimation2) => {
  LinkIconAnimation2["SlideStart"] = "slide-start";
  LinkIconAnimation2["SlideEnd"] = "slide-end";
  return LinkIconAnimation2;
})(LinkIconAnimation || {});
export var LinkTheme = /* @__PURE__ */ ((LinkTheme2) => {
  LinkTheme2["Dark"] = "dark";
  LinkTheme2["Light"] = "light";
  return LinkTheme2;
})(LinkTheme || {});
const Link = React.forwardRef(
  (_a, ref) => {
    var _b = _a, { href, rel, onClick, target, children, className, iconStart, iconEnd, iconAnimation, id, disabled } = _b, rest = __objRest(_b, ["href", "rel", "onClick", "target", "children", "className", "iconStart", "iconEnd", "iconAnimation", "id", "disabled"]);
    const isExternal = (href == null ? void 0 : href.includes("://")) && href[0] !== "#";
    const defaultRel = isExternal ? "noopener noreferrer" : void 0;
    const defaultTarget = isExternal ? "_blank" : void 0;
    const linkRel = rel != null ? rel : defaultRel;
    const linkTarget = target != null ? target : defaultTarget;
    const Component = !!onClick && !href ? "button" : "a";
    return /* @__PURE__ */ React.createElement(
      Component,
      __spreadValues({
        className: classNames("kl-link", styles.link, className),
        href: disabled ? void 0 : href,
        rel: linkRel,
        target: linkTarget,
        onClick: disabled ? void 0 : onClick,
        disabled,
        "aria-disabled": disabled,
        role: "link",
        id,
        ref
      }, rest),
      !!iconStart && /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__icon", styles.icon({ position: "start", animation: iconAnimation })) }, iconStart),
      /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__text", styles.text) }, children),
      !!iconEnd && /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__icon", styles.icon({ position: "end", animation: iconAnimation })) }, iconEnd)
    );
  }
);
export default Link;
